import { UUID } from '~/types/common';
import { RouterContext } from '~/types/router.type';

import { getContractQueryOptions } from '~/data/contract';

import { getContractNumberLabel } from '~/modules/contract/utils';

export async function getContract({
  context,
  params,
}: {
  context: RouterContext;
  params: { contractId: UUID };
}) {
  const { contractId } = params;
  const { queryClient } = context;

  let contractName = '';
  try {
    const contract = await queryClient.query(
      getContractQueryOptions({ contractId }),
    );

    contractName = getContractNumberLabel(contract.buyerAssignedId);
  } catch (error) {
    // Don't throw so we can show a specific error page in case the contract is not found
  }

  return {
    ...context,
    pageData: {
      title: contractName,
    },
  };
}
